/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Teams_Leader_HintInputs */

const cs_settings_teams_leader_hint = /** @type {(inputs: Settings_Teams_Leader_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte vedoucího, aby tým měl jasného vlastníka.`)
};

const en_settings_teams_leader_hint = /** @type {(inputs: Settings_Teams_Leader_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a leader so the team has a default owner.`)
};

/**
* | output |
* | --- |
* | "Pick a leader so the team has a default owner." |
*
* @param {Settings_Teams_Leader_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_teams_leader_hint = /** @type {((inputs?: Settings_Teams_Leader_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Teams_Leader_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_teams_leader_hint(inputs)
	return cs_settings_teams_leader_hint(inputs)
});